import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FULL_DATE_PATTERN, Personality } from 'src/app/@core/constants';
import { CreditRequestUtils } from 'src/app/@core/utils/credit-request-utils';
import { FileUtils } from 'src/app/@core/utils/file-utils';
import { ObjectUtils } from 'src/app/@core/utils/object-utils';
import { PosValidators } from 'src/app/@core/validators/pos-validators';
import { CreditRequest } from 'src/app/models/credit-request';
import { CreditRequestBankReferenceInformation } from 'src/app/models/credit-request-bank-reference-information';
import { CreditRequestContactInformation } from 'src/app/models/credit-request-contact-information';
import { CreditRequestData } from 'src/app/models/credit-request-data';
import { Customer } from 'src/app/models/customer';
import { FiscalIdTypes } from 'src/app/models/fiscalIdTypes';
import { Nationality } from 'src/app/models/nationality';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';
import { OnbaseDoc } from 'src/app/models/onbase-doc';
import { ResponseModel } from 'src/app/models/response-model';
import { CreditStatusFranchisedResponseModel } from 'src/app/models/response/customerCreditStatusResponseModel';
import { OnbaseProcedureResponseModel } from 'src/app/models/response/onbaseProcedureResponseModel';
import { CityService } from 'src/app/services/city.service';
import { ColonyService } from 'src/app/services/colony.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CreditService } from 'src/app/services/credit.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { FiscalIdService } from 'src/app/services/fiscal-id.service';
import { NationalityService } from 'src/app/services/nationality.service';
import { OnbaseService } from 'src/app/services/onbase.service';
import { RegionService } from 'src/app/services/region.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-legal-entity-credit-plan-stepper',
  templateUrl: './legal-entity-credit-plan-stepper.component.html',
  styleUrls: ['./legal-entity-credit-plan-stepper.component.sass']
})
export class LegalEntityCreditPlanStepperComponent implements OnInit {

  generalnformationForm: FormGroup = new FormGroup({});
  companyInformationForm: FormGroup = new FormGroup({});
  companyAddressInformationForm: FormGroup = new FormGroup({});
  companyContactInformationForm: FormArray = new FormArray([]);
  companyBankingReferenceForm: FormArray = new FormArray([]);
  bankRepresentativeForm: FormGroup = new FormGroup({});
  observationForm: FormGroup = new FormGroup({});
  documentsForm: FormArray = new FormArray([]);
  creditPlan: OnbaseProcedureResponseModel = new OnbaseProcedureResponseModel();
  customerCreditConditions: CreditStatusFranchisedResponseModel = new CreditStatusFranchisedResponseModel();
  customer: Customer = new Customer();
  seller: any;
  onbaseCatalogue: OnbaseCatalogue = new OnbaseCatalogue();
  onbaseDocs: Array<OnbaseDoc> = [];
  fiscalIdTypes: Array<FiscalIdTypes> = [];
  nationalities: Nationality[] = [];
  request: CreditRequest = new CreditRequest();
  isDraft: boolean = false;
  selectedIndex = 0;
  constructor(private fb: FormBuilder, private router: Router, private onbaseService: OnbaseService, private fiscalIdTypeService: FiscalIdService, private configService: ConfigurationService, private nationalityService: NationalityService, private regionService: RegionService, private cityService: CityService, private colonyService: ColonyService, private datePipe: DatePipe, private toastr: ToastrService, private creditService: CreditService, private readonly exceptionSolutionService: ExceptionSolutionService) {

    if (!this.router.getCurrentNavigation()?.extras.state) {
      this.router.navigate(["creditRequests"]);
    }
    this.creditPlan = this.router.getCurrentNavigation()?.extras.state?.creditPlan as OnbaseProcedureResponseModel || new OnbaseProcedureResponseModel();
    this.customerCreditConditions = this.router.getCurrentNavigation()?.extras.state?.customerCreditConditions as CreditStatusFranchisedResponseModel || new CreditStatusFranchisedResponseModel();
    this.customer = this.router.getCurrentNavigation()?.extras.state?.customer as Customer || new Customer();
    this.seller = this.router.getCurrentNavigation()?.extras.state?.seller;
    if (this.router.getCurrentNavigation()?.extras.state?.isDraft) {
      this.request = this.router.getCurrentNavigation()?.extras.state?.request;
      this.isDraft = true;
    }

    this.configureForms();

  }

  async ngOnInit(): Promise<void> {
    this.onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
    this.fiscalIdTypes = (await this.fiscalIdTypeService.readFiscalIds().toPromise()).response;
    this.onbaseDocs = (await this.onbaseService.readOnBaseDocs().toPromise()).response;
    this.nationalities = (await this.nationalityService.readNationalities().toPromise()).response.content;
    if (!this.isDraft) {
      this.configureForms();
    }
    else {
      await this.configureFormsFromRequest();
    }
  }


  async configureFormsFromRequest() {
    //this.configureForms();
    this.configureGeneralFormFromRequest();
    this.configureBankRepresentativeFormFromRequest();
    this.configureCompanyInformationFormRequest();
    this.configureCompanyAddressInformationFormFromRequest();
    this.configureContactInformationFormFromRequest()
    this.configureBankingReferenceFormFromRequest()
    this.configureObservationsFormFromRequest();
    await this.configureDocumentsFormFromRequest();

  }
  async configureDocumentsFormFromRequest() {
    this.configureDocumentsForm();
    let files = (await this.onbaseService.listFilesDraft(this.request.code).toPromise());
    if (files && files.response.documents) {
      files.response.documents.forEach(f => {
        let form = this.documentsForm.controls.find(x => x.value.id == f.documentType) as FormGroup;

        let formArray = form.get("documents") as FormArray;

        formArray.at(parseInt(f.id)).patchValue({
          [`document_${f.documentType}_${f.id}`]: FileUtils.dataURLtoBlob(f.file),
          [`document_documentType_${f.documentType}_${f.id}`]: f.fileType,
          [`document_ext_${f.documentType}_${f.id}`]: f.extentionFile,
          [`document_fileName_${f.documentType}_${f.id}`]: f.fileName
        })
      })
    }
  }

  configureBankRepresentativeFormFromRequest() {
    this.bankRepresentativeForm = this.fb.group({
      mainRequestCode: new FormControl(this.request.requestData.Codigo_Solicitud_Principal)
    })
  }

  configureObservationsFormFromRequest() {
    this.observationForm = new FormGroup({
      observationText: new FormControl(this.request.requestData.Observaciones_Ventas)
    })
    this.observationForm.markAsTouched();
  }

  configureBankingReferenceFormFromRequest() {
    this.request.requestData.ListaReferenciasBancarias.forEach(m => {
      let f = new FormGroup({
        name: new FormControl(m.DRB_Nombre_encargado_confirmar, Validators.required),
        institutionName: new FormControl(m.DRB_Nombre_institucion, Validators.required),
        relationshipInitialDate: new FormControl(m.DRB_Fecha_inicio_relacion ? new Date(m.DRB_Fecha_inicio_relacion) : "", Validators.required),
        phone: new FormControl(m.DRB_Telefono, Validators.required),
        phoneExtension: new FormControl(m.DRB_Telefono_Extension),
        relationshipType: new FormControl(m.DRB_Tip_relacion, Validators.required),
      })
      this.companyBankingReferenceForm.push(f);
    })

  }

  configureContactInformationFormFromRequest() {

    this.request.requestData.ListaContactosEncargadosPago.forEach(m => {
      let f = new FormGroup({
        firstName: new FormControl(m.Primer_Nombre, Validators.required),
        middleName: new FormControl(m.Segundo_Nombre),
        lastName: new FormControl(m.Primer_Apellido, Validators.required),
        secondLastName: new FormControl(m.Segundo_Apellido),
        contactPosition: new FormControl(m.Cargo_Contacto, Validators.required),
        mobilePhone: new FormControl(m.Celular, Validators.required),
        phone: new FormControl(m.Telefono, Validators.required),
        phoneExtension: new FormControl(m.Telefono_Extension),
        email: new FormControl(m.Correo_Electronico, [Validators.required, Validators.email])
      });
      this.companyContactInformationForm.push(f);
    })
  }


  configureCompanyAddressInformationFormFromRequest() {
    this.companyAddressInformationForm = new FormGroup({
      localType: new FormControl(this.request.requestData.Tipo_Vivienda, Validators.required),
      country: new FormControl(this.request.requestData.Pais_Trabajo, Validators.required),
      deparment: new FormControl(this.request.requestData.Departamento_Empresa, Validators.required),
      city: new FormControl(this.request.requestData.Ciudad_Municipio_Empresa, Validators.required),
      neighborhood: new FormControl(this.request.requestData.Aldea_Barrio_Caserio_Colonia_Empresa, Validators.required),
      street: new FormControl(this.request.requestData.Calle1_Empresa, Validators.required),
      street2: new FormControl(this.request.requestData.Calle2_Empresa),
      street3: new FormControl(this.request.requestData.Calle3_Empresa),
      street4: new FormControl(this.request.requestData.Calle4_Empresa),
      street5: new FormControl(this.request.requestData.Calle5_Empresa),
      companyPhone: new FormControl(this.request.requestData.Telefono_Empresa, Validators.required),
      companyExtension: new FormControl(this.request.requestData.Extension_Telefono_Empresa),
    });

    this.configureCompanyAddressInformationFormFields();
  }

  configureCompanyInformationFormRequest() {
    this.companyInformationForm = new FormGroup({
      legalName: new FormControl(this.customer.mainPersonalInfo?.fullName),
      fiscalId: new FormControl(this.customer.mainPersonalInfo?.fiscalId),
      nationality: new FormControl(this.customer.mainPersonalInfo?.nationality),
      fiscalIdType: new FormControl(this.customer.mainPersonalInfo?.fiscalIdType),
      fiscalIdName: new FormControl(this.fiscalIdTypes.find(f => f.code == this.customer.mainPersonalInfo?.fiscalIdType)?.name),
      economicActivity: new FormControl(this.request.requestData.Giro_Actividad_economica, Validators.required),
      commercialName: new FormControl(this.request.requestData.Nombre_Comercial, Validators.required),
      operationDate: new FormControl(this.request.requestData.Fecha_inicio_operaciones ? new Date(this.request.requestData.Fecha_inicio_operaciones) : "", Validators.required),
      companySize: new FormControl(this.request.requestData.Tamano_empresa, Validators.required),
      amountEmployees: new FormControl(this.request.requestData.Numero_Empleados, [Validators.required, Validators.min(1)]),
    });
    this.companyInformationForm.markAsTouched();
  }
  configureGeneralFormFromRequest() {
    this.generalnformationForm = this.fb.group({
      personality: new FormControl(this.customer.mainPersonalInfo?.personality),
      personalityDescription: new FormControl(CreditRequestUtils.getPersonalityDescription(this.customer.mainPersonalInfo?.personality || "")),
      requestType: new FormControl(this.request.requestData.Tipo_Solicitante, Validators.required),
      creditPlan: new FormControl(this.creditPlan.code),
      creditPlanDescription: new FormControl(this.creditPlan.name),
      sellerCode: new FormControl(this.seller?.code || this.seller?.username || ""),
      sellerName: new FormControl(this.seller?.fullName || this.seller?.fullname || "")

    });
  }

  configureForms() {
    this.configureGeneralForm();
    this.configureBankRepresentativeForm();
    this.configureCompanyInformationForm();
    this.configureCompanyAddressInformationForm();
    this.configureContactInformationForm();
    this.configureBankingReferenceForm();
    this.configureObservationsForm();
    this.configureDocumentsForm();
  }

  configureBankRepresentativeForm() {
    this.bankRepresentativeForm = this.fb.group({
      mainRequestCode: new FormControl("")
    });
  }

  configureGeneralForm() {
    this.generalnformationForm = this.fb.group({
      personality: new FormControl(this.customer.mainPersonalInfo?.personality),
      personalityDescription: new FormControl(CreditRequestUtils.getPersonalityDescription(this.customer.mainPersonalInfo?.personality || "")),
      requestType: new FormControl("CUSTOMER", Validators.required),
      creditPlan: new FormControl(this.creditPlan.code),
      creditPlanDescription: new FormControl(this.creditPlan.name),
      sellerCode: new FormControl(this.seller?.code || this.seller?.username || ""),
      sellerName: new FormControl(this.seller?.fullName || this.seller?.fullname || "")

    });

    this.configureGeneralFormFields();
  }

  private configureGeneralFormFields() {
    this.generalnformationForm.get("personality")?.disable({ onlySelf: true });
    this.generalnformationForm.get("personalityDescription")?.disable({ onlySelf: true });
    this.generalnformationForm.get("requestType")?.markAsTouched();
    this.generalnformationForm.get("requestType")?.markAsDirty();
    this.generalnformationForm.get("requestType")?.enable();
    this.generalnformationForm.get("creditPlan")?.disable({ onlySelf: true });
    this.generalnformationForm.get("creditPlanDescription")?.disable({ onlySelf: true });
    this.generalnformationForm.get("sellerCode")?.disable({ onlySelf: true });
    this.generalnformationForm.get("sellerName")?.disable({ onlySelf: true });
  }

  configureCompanyInformationForm() {
    this.companyInformationForm = new FormGroup({
      legalName: new FormControl(this.customer.mainPersonalInfo?.fullName),
      fiscalId: new FormControl(this.customer.mainPersonalInfo?.fiscalId),
      nationality: new FormControl(this.customer.mainPersonalInfo?.nationality),
      fiscalIdType: new FormControl(this.customer.mainPersonalInfo?.fiscalIdType),
      fiscalIdName: new FormControl(this.fiscalIdTypes.find(f => f.code == this.customer.mainPersonalInfo?.fiscalIdType)?.name),
      economicActivity: new FormControl("", Validators.required),
      commercialName: new FormControl("", Validators.required),
      operationDate: new FormControl("", Validators.required),
      companySize: new FormControl("", Validators.required),
      amountEmployees: new FormControl("", [Validators.required, Validators.min(1)]),
    });

    this.configureCompanyInformationFormFields();

  }

  private configureCompanyInformationFormFields() {
    this.companyInformationForm.get("legalName")?.disable({ onlySelf: true });
    this.companyInformationForm.get("fiscalId")?.disable({ onlySelf: true });
    this.companyInformationForm.get("fiscalIdName")?.disable({ onlySelf: true });
    this.companyInformationForm.get("nationality")?.disable({ onlySelf: true });
    this.companyInformationForm.get("fiscalIdType")?.disable({ onlySelf: true });
    this.companyInformationForm.get("economicActivity")?.markAsDirty();
    this.companyInformationForm.get("companySize")?.markAsDirty();
    this.companyInformationForm.get("economicActivity")?.enable();
    this.companyInformationForm.get("commercialName")?.enable();
    this.companyInformationForm.get("operationDate")?.enable();
    this.companyInformationForm.get("companySize")?.enable();
    this.companyInformationForm.get("amountEmployees")?.enable();
  }

  configureCompanyAddressInformationForm() {
    this.companyAddressInformationForm = new FormGroup({
      localType: new FormControl("", Validators.required),
      country: new FormControl(this.customer.mainPersonalInfo?.nationality, Validators.required),
      deparment: new FormControl("", Validators.required),
      city: new FormControl("", Validators.required),
      neighborhood: new FormControl("", Validators.required),
      street: new FormControl("", Validators.required),
      street2: new FormControl(""),
      street3: new FormControl(""),
      street4: new FormControl(""),
      street5: new FormControl(""),
      companyPhone: new FormControl("", Validators.required),
      companyExtension: new FormControl(""),
    });

    this.configureCompanyAddressInformationFormFields();
  }

  private configureCompanyAddressInformationFormFields() {
    this.companyAddressInformationForm.get("localType")?.markAsDirty();
    this.companyAddressInformationForm.get("country")?.markAsDirty();
    this.companyAddressInformationForm.get("deparment")?.markAsDirty();
    this.companyAddressInformationForm.get("city")?.markAsDirty();
    this.companyAddressInformationForm.get("neighborhood")?.markAsDirty();
    this.companyAddressInformationForm.get("localType")?.enable();
    this.companyAddressInformationForm.get("country")?.enable();
    this.companyAddressInformationForm.get("deparment")?.enable();
    this.companyAddressInformationForm.get("city")?.enable();
    this.companyAddressInformationForm.get("neighborhood")?.enable();
    this.companyAddressInformationForm.get("street")?.enable();
    this.companyAddressInformationForm.get("street2")?.enable();
    this.companyAddressInformationForm.get("street3")?.enable();
    this.companyAddressInformationForm.get("street4")?.enable();
    this.companyAddressInformationForm.get("street5")?.enable();
    this.companyAddressInformationForm.get("companyPhone")?.enable();
    this.companyAddressInformationForm.get("companyExtension")?.enable();
  }

  configureContactInformationForm() {
    this.companyContactInformationForm.setValidators([Validators.required]);
    this.companyContactInformationForm.enable();
    this.companyContactInformationForm.markAsTouched();
  }
  configureBankingReferenceForm() {
    this.companyBankingReferenceForm.setValidators([Validators.required]);
    this.companyBankingReferenceForm.enable();
    this.companyBankingReferenceForm.markAsTouched();
  }

  configureObservationsForm() {
    this.observationForm = new FormGroup({
      observationText: new FormControl("")
    });

    this.observationForm.get("observationText")?.markAsDirty()
    this.observationForm.get("observationText")?.enable()
  }

  configureDocumentsForm() {
    this.documentsForm = new FormArray([]);
    ObjectUtils.objectToArray(this.creditPlan.documents || {}).forEach(m => {

      let arrayOfDocuments = m.value as Array<string>;

      let documents = new FormArray([]);

      arrayOfDocuments.forEach((x, i) => {
        documents.push(new FormGroup({
          [`description_${m.key}_${i.toString()}`]: new FormControl(x),
          [`document_fileName_${m.key}_${i.toString()}`]: new FormControl(""),
          [`document_${m.key}_${i.toString()}`]: new FormControl(""),
          [`document_ext_${m.key}_${i.toString()}`]: new FormControl(""),
          [`document_documentType_${m.key}_${i.toString()}`]: new FormControl("")
        }))
      })

      let formToPush = new FormGroup({
        id: new FormControl(m.key),
        description: new FormControl(this.onbaseDocs.find(x => x.code == m.key)?.name),
        documents: documents
      });
      this.documentsForm.push(formToPush);
    })

    this.documentsForm.setValidators(PosValidators.validateDocuments);
    this.documentsForm.markAsTouched();
  }


  getMap() {
    let map = new Map<string, AbstractControl>();
    map.set("generalnformationForm", this.generalnformationForm);
    map.set("bankRepresentativeForm", this.bankRepresentativeForm);
    map.set("companyInformationForm", this.companyInformationForm);
    map.set("companyAddressInformationForm", this.companyAddressInformationForm);
    map.set("companyContactInformationForm", this.companyContactInformationForm);
    map.set("companyBankingReferenceForm", this.companyBankingReferenceForm);
    map.set("observationForm", this.observationForm);
    map.set("documentsForm", this.documentsForm);

    return map;
    //
  }
  enableForms(event: StepperSelectionEvent) {
    const indexCondition = this.showRepresentativeStep() ? 8 : 7;
    this.selectedIndex = event.selectedIndex;
    if (event.selectedIndex == indexCondition) {
      this.updateValues();
    }
    else {
      this.reenableForms();
    }

  }

  reenableForms() {
    this.configureGeneralFormFields();
    this.configureCompanyInformationFormFields();
    this.configureCompanyAddressInformationFormFields();
    this.configureContactInformationForm();
    this.configureBankingReferenceForm();
    this.documentsForm.enable();
    this.observationForm.get("observationText")?.enable();
    this.observationForm.markAsTouched();
    this.bankRepresentativeForm.enable();
  }

  private updateValues() {
    this.generalnformationForm.patchValue(this.generalnformationForm.getRawValue());
    this.companyInformationForm.patchValue(this.companyInformationForm.value);
    this.companyAddressInformationForm.patchValue(this.companyAddressInformationForm.value);
    this.companyContactInformationForm.patchValue(this.companyContactInformationForm.value);
    this.companyBankingReferenceForm.patchValue(this.companyBankingReferenceForm.value);
    this.observationForm.patchValue(this.observationForm.value);
    this.documentsForm.patchValue(this.documentsForm.value);
    this.bankRepresentativeForm.patchValue(this.bankRepresentativeForm.value);
  }


  async createRequest(isDraft: boolean) {
    let requestData = new CreditRequestData();

    await this.buildRequest(requestData, isDraft);
    if (!this.isDraft) {
      (await this.onbaseService.createOnBaseRequest(requestData, isDraft).toPromise().then(async x => {
        await this.successSendCreditRequest(requestData, x, isDraft);
      }).catch((error: HttpErrorResponse) => {
        this.exceptionSolutionService.showAlertWithSolution(`Solicitud de Crédito`, `Error al querer crear la solicitud ${error}`, undefined, 'error');
      }));
    }
    else {
      (await this.onbaseService.updateOnBaseRequest(this.request.code, requestData, isDraft).toPromise().then(async x => {
        await this.successSendCreditRequest(requestData, x, isDraft);
      }).catch((error: HttpErrorResponse) => {
        this.exceptionSolutionService.showAlertWithSolution(`Solicitud de Crédito ${this.request.code}`, `Error al querer modificar la solicitud ${error}`, undefined, 'error');
      }));
    }

  }

  private async successSendCreditRequest(requestData: CreditRequestData, x: ResponseModel<CreditRequest>, isDraft: boolean) {
    if (this.generalnformationForm.value.requestType == "AVAL") {
      await this.onbaseService.updateBankGuarantee(requestData.Codigo_Solicitud_Principal, x.response.code).toPromise();
    }
    await this.sendDocuments(isDraft, x);
    this.router.navigate(["creditRequests", x.response.code]);
  }

  private async sendDocuments(isDraft: boolean, x: ResponseModel<CreditRequest>) {
    if (!isDraft) {
      if (!x.response.code) {
        this.exceptionSolutionService.showAlertWithSolution(`Solicitudes de Crédito`, `Hubo un error al querer crear la solicitud de crédito: ${x.response}`);
        return;
      }
      await this.onbaseService.sendDocuments(x.response.code, this.customer.mainPersonalInfo?.fiscalId || "", this.documentsForm).catch((error: HttpErrorResponse) => {
        this.exceptionSolutionService.showAlertWithSolution(`Solicitudes de Crédito`, `La solicitud con código ${x.response.code} se ha creado pero hubo un error al querer guardar los documentos`)
        this.router.navigate(["creditRequests", x.response.code]);
      });
      Swal.fire({
        title: `Solicitudes de Crédito`,
        text: `La solicitud con código ${x.response.code} se ha creado con éxito`,
        icon: 'success',
        confirmButtonText: 'Aceptar',
      });
    }
    else {
      await (await this.onbaseService.sendDocumentsDraft(x.response.code, this.customer.mainPersonalInfo?.fiscalId || "", this.documentsForm)).toPromise().catch((error: HttpErrorResponse) => {
        this.exceptionSolutionService.showAlertWithSolution(`Solicitudes de Crédito`, `La solicitud con código ${x.response.code} se ha creado en borradores pero hubo un error al querer guardar los documentos`)
        this.router.navigate(["creditRequests", x.response.code]);
      });
      Swal.fire({
        title: `Solicitudes de Crédito`,
        text: `La solicitud con código ${x.response.code} se ha creado en borradores`,
        icon: 'success',
        confirmButtonText: 'Aceptar',
      });
    }
  }

  private async buildRequest(requestData: CreditRequestData, isDraft: boolean) {
    if (!isDraft) {
      await this.buildRequestCreate(requestData);
    }
    else {
      this.buildRequestDraft(requestData);
    }
  }

  buildRequestDraft(requestData: CreditRequestData) {
    requestData.Tramite = this.generalnformationForm.getRawValue().creditPlanDescription;
    requestData.Vendedor = this.generalnformationForm.getRawValue().sellerCode;
    requestData.Nombre = this.generalnformationForm.getRawValue().sellerName;
    requestData.Segmento = "HN_001";
    requestData.Tipo_Cliente = "JURIDICA";
    requestData.Observaciones_Ventas = this.observationForm.value.observationText;
    requestData.Tipo_Solicitante = this.generalnformationForm.value.requestType;
    requestData.ID_Tipo_Tramite = this.creditPlan.code;
    requestData.Codigo_Cliente_BP = this.customer.code;
    requestData.Codigo_Solicitud_Principal = this.bankRepresentativeForm.value.mainRequestCode;
    //requestData.codigoSolicitudAval = "";
    //requestData.clienteAsociado="";
    requestData.Origen = "TIENDA";
    requestData.ID_Causa = CreditRequestUtils.getIdCause(this.customerCreditConditions.estadoCliente);
    requestData.Monto_Sugerido_Credito = this.creditPlan.credit.toString();
    requestData.Monto_Aprobado = "0";
    requestData.Division = this.configService.readSelectedBranchAndSalesOrg().branch.name;
    requestData.Empresa = this.configService.readSelectedBranchAndSalesOrg().salesOrg.name;
    requestData.ID_TipoIdentificacion = this.companyInformationForm.getRawValue().fiscalIdType;
    requestData.ReglaLimite = this.creditPlan.limitRule;
    requestData.Nacionalidad = this.customer.mainPersonalInfo?.nationality || "";
    requestData.Identificacion = this.companyInformationForm.getRawValue().fiscalId;
    requestData.Tipo_Identificacion = this.companyInformationForm.getRawValue().fiscalIdName;
    requestData.Giro_Actividad_economica = this.companyInformationForm.value.economicActivity
    requestData.Nombre_Comercial = this.companyInformationForm.value.commercialName;
    requestData.Nombre_Legal = this.companyInformationForm.getRawValue().legalName;
    requestData.Fecha_inicio_operaciones = this.datePipe.transform(this.companyInformationForm.value.operationDate, FULL_DATE_PATTERN) || "";
    //requestData.Fecha_inicio_operaciones = "20202-20202-2-2020";
    requestData.Tamano_empresa = this.companyInformationForm.value.companySize;
    requestData.Numero_Empleados = this.companyInformationForm.value.amountEmployees;
    requestData.Tipo_Vivienda = this.companyAddressInformationForm.value.localType;
    requestData.Pais_Trabajo = this.companyAddressInformationForm.value.country;
    requestData.Departamento_Empresa = this.companyAddressInformationForm.value.deparment;
    requestData.Ciudad_Municipio_Empresa = this.companyAddressInformationForm.value.city;
    requestData.Aldea_Barrio_Caserio_Colonia_Empresa = this.companyAddressInformationForm.value.neighborhood;
    requestData.Calle1_Empresa = this.companyAddressInformationForm.value.street;
    requestData.Calle2_Empresa = this.companyAddressInformationForm.value.street2;
    requestData.Calle3_Empresa = this.companyAddressInformationForm.value.street3;
    requestData.Calle4_Empresa = this.companyAddressInformationForm.value.street4;
    requestData.Calle5_Empresa = this.companyAddressInformationForm.value.street5;
    requestData.Telefono_Empresa = this.companyAddressInformationForm.value.companyPhone;
    requestData.Extension_Telefono_Empresa = this.companyAddressInformationForm.value.companyExtension;
    requestData.ListaContactosEncargadosPago = this.companyContactInformationForm.controls.map(m => {
      m.enable();
      let contactInfo = new CreditRequestContactInformation();
      contactInfo.Cargo_Contacto = m.value.contactPosition;
      contactInfo.Celular = m.value.mobilePhone;
      contactInfo.Correo_Electronico = m.value.email;
      contactInfo.Primer_Nombre = m.value.firstName;
      contactInfo.Segundo_Nombre = m.value.middleName;
      contactInfo.Primer_Apellido = m.value.lastName;
      contactInfo.Segundo_Apellido = m.value.secondLastName;
      contactInfo.Telefono = m.value.phone;
      contactInfo.Telefono_Extension = m.value.phoneExtension;
      contactInfo.objIdContacto = "0";
      contactInfo.valid = m.valid;
      return contactInfo;
    });
    requestData.ListaReferenciasBancarias = this.companyBankingReferenceForm.controls.map(m => {
      m.enable();
      let reference = new CreditRequestBankReferenceInformation();
      reference.DRB_Fecha_inicio_relacion = this.datePipe.transform(m.value.relationshipInitialDate || "", FULL_DATE_PATTERN) || "";
      reference.DRB_Nombre_encargado_confirmar = m.value.name;
      reference.DRB_Nombre_institucion = m.value.institutionName;
      reference.DRB_Telefono = m.value.phone;
      reference.DRB_Telefono_Extension = m.value.phoneExtension;
      reference.DRB_Tip_relacion = m.value.relationshipType;
      reference.valid = m.valid;
      return reference;
    });
  }

  private async buildRequestCreate(requestData: CreditRequestData) {
    requestData.Tramite = this.generalnformationForm.getRawValue().creditPlanDescription;
    requestData.Vendedor = this.generalnformationForm.getRawValue().sellerCode;
    requestData.Nombre = this.generalnformationForm.getRawValue().sellerName;
    requestData.Segmento = "HN_001";
    requestData.Tipo_Cliente = "JURIDICA";
    requestData.Observaciones_Ventas = this.observationForm.value.observationText;
    requestData.Tipo_Solicitante = this.generalnformationForm.value.requestType == "AVAL" ? await this.getEndorsementType() : "CLIENTE";
    requestData.ID_Tipo_Tramite = this.creditPlan.code;
    requestData.Codigo_Cliente_BP = this.customer.code;
    //TODO: AVAL
    requestData.Codigo_Solicitud_Principal = this.bankRepresentativeForm.value.mainRequestCode;
    //requestData.codigoSolicitudAval = "";
    //requestData.clienteAsociado="";
    requestData.Origen = "TIENDA";
    requestData.ID_Causa = CreditRequestUtils.getIdCause(this.customerCreditConditions.estadoCliente);
    requestData.Monto_Sugerido_Credito = this.creditPlan.credit.toString();
    requestData.Division = this.configService.readSelectedBranchAndSalesOrg().branch.name;
    requestData.Empresa = this.configService.readSelectedBranchAndSalesOrg().salesOrg.name;
    requestData.Monto_Aprobado = "0";
    requestData.ID_TipoIdentificacion = this.companyInformationForm.getRawValue().fiscalIdType;
    requestData.ReglaLimite = this.creditPlan.limitRule;
    requestData.Nacionalidad = this.nationalities.find(f => f.code == this.customer.mainPersonalInfo?.nationality)?.name || this.customer.mainPersonalInfo?.nationality || "";
    requestData.Identificacion = this.companyInformationForm.getRawValue().fiscalId;
    requestData.Tipo_Identificacion = this.companyInformationForm.getRawValue().fiscalIdName;
    requestData.Giro_Actividad_economica = this.onbaseCatalogue.economicActivity.find(f => f.key == this.companyInformationForm.value.economicActivity)?.description || "";
    requestData.Nombre_Comercial = this.companyInformationForm.value.commercialName;
    requestData.Nombre_Legal = this.companyInformationForm.getRawValue().legalName;
    requestData.Fecha_inicio_operaciones = this.datePipe.transform(this.companyInformationForm.value.operationDate, FULL_DATE_PATTERN) || "";
    //requestData.Fecha_inicio_operaciones = "20202-20202-2-2020";
    requestData.Tamano_empresa = this.onbaseCatalogue.companySize[this.companyInformationForm.value.companySize];
    requestData.Numero_Empleados = this.companyInformationForm.value.amountEmployees;
    requestData.Tipo_Vivienda = this.onbaseCatalogue.homeType[this.companyAddressInformationForm.value.localType];
    requestData.Pais_Trabajo = this.nationalities.find(f => f.code == this.companyAddressInformationForm.value.country)?.country || "";
    requestData.Departamento_Empresa = (await this.regionService.readRegions(this.companyAddressInformationForm.value.country, this.companyAddressInformationForm.value.deparment).toPromise()).response.content[0].name;
    requestData.Ciudad_Municipio_Empresa = (await this.cityService.readCities(this.companyAddressInformationForm.value.country, this.companyAddressInformationForm.value.deparment).toPromise()).response.content.find(f => f.cityCode == this.companyAddressInformationForm.value.city)?.name || this.companyAddressInformationForm.value.city;
    requestData.Aldea_Barrio_Caserio_Colonia_Empresa = (await this.colonyService.readColonies(this.companyAddressInformationForm.value.city).toPromise()).response.content.find(f => f.code == this.companyAddressInformationForm.value.neighborhood)?.name || this.companyAddressInformationForm.value.neighborhood;
    requestData.Calle1_Empresa = this.companyAddressInformationForm.value.street;
    requestData.Calle2_Empresa = this.companyAddressInformationForm.value.street2;
    requestData.Calle3_Empresa = this.companyAddressInformationForm.value.street3;
    requestData.Calle4_Empresa = this.companyAddressInformationForm.value.street4;
    requestData.Calle5_Empresa = this.companyAddressInformationForm.value.street5;
    requestData.Telefono_Empresa = this.companyAddressInformationForm.value.companyPhone;
    requestData.Extension_Telefono_Empresa = this.companyAddressInformationForm.value.companyExtension;
    requestData.ListaContactosEncargadosPago = this.companyContactInformationForm.controls.map(m => {
      m.enable();
      let contactInfo = new CreditRequestContactInformation();
      contactInfo.Cargo_Contacto = this.onbaseCatalogue.businessPosition[m.value.contactPosition];
      contactInfo.Celular = m.value.mobilePhone;
      contactInfo.Correo_Electronico = m.value.email;
      contactInfo.Primer_Nombre = m.value.firstName;
      contactInfo.Segundo_Nombre = m.value.middleName;
      contactInfo.Primer_Apellido = m.value.lastName;
      contactInfo.Segundo_Apellido = m.value.secondLastName;
      contactInfo.Telefono = m.value.phone;
      contactInfo.Telefono_Extension = m.value.phoneExtension;
      contactInfo.objIdContacto = "0";
      contactInfo.valid = m.valid;
      return contactInfo;
    });
    requestData.ListaReferenciasBancarias = this.companyBankingReferenceForm.controls.map(m => {
      m.enable();
      let reference = new CreditRequestBankReferenceInformation();
      reference.DRB_Fecha_inicio_relacion = this.datePipe.transform(m.value.relationshipInitialDate, FULL_DATE_PATTERN) || "";
      reference.DRB_Nombre_encargado_confirmar = m.value.name;
      reference.DRB_Nombre_institucion = m.value.institutionName;
      reference.DRB_Telefono = m.value.phone;
      reference.DRB_Telefono_Extension = m.value.phoneExtension;
      reference.DRB_Tip_relacion = this.onbaseCatalogue.businessPosition[m.value.relationshipType]
      reference.valid = m.valid;
      return reference;
    });
  }

  showRepresentativeStep() {
    return this.generalnformationForm.value.requestType == "AVAL";
  }

  goToStep(step: string) {

    this.selectedIndex = this.getStepMap(step);
  }

  getStepMap(step: string) {
    let stepMap = new Map<string, number>();
    let index = 0;
    stepMap.set("generalnformationForm", index++);
    if (this.showRepresentativeStep()) {
      stepMap.set("bankRepresentativeForm", index++);
    }
    stepMap.set("companyInformationForm", index++);
    stepMap.set("companyAddressInformationForm", index++);
    stepMap.set("companyContactInformationForm", index++);
    stepMap.set("companyBankingReferenceForm", index++);
    stepMap.set("observationForm", index++)
    stepMap.set("documentsForm", index++);
    return stepMap.get(step) || 0;
  }
  async getEndorsementType(): Promise<string> {
    const creditRequest = (await this.onbaseService.readOnbaseRequestByCode(this.bankRepresentativeForm.value.mainRequestCode).toPromise()).response;
    return creditRequest.customer.mainPersonalInfo.personality == Personality.LEGAL_ENTITY ? "REPRESENTANTE" : "AVAL";
  }
}
